import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
import { CircularProgress, Box, IconButton, Tooltip, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import Leftmenu from './menu/Leftmenu';
import Appbar from './Appbar';
import useAuth from '../../auth_services/useAuth';
import AlertPopup from '../../components/modal/AlertPopup';
import '../../css/table_style.css';

const MainLayoutOld = () => {
    const navigate = useNavigate();
    // setOutletContext for set attribute value from route children element
    const [outletContext, setOutletContext] = useState("");
    const location = useLocation();

    // Check login for loading page
    const [loading, setLoading] = useState(false);
    const axiosPrivate = useAxiosPrivate();

    // Set alert props
    const [alertPopup, setAlertPopup] = useState({ open: false });

    const [menuSmall, setMenuSmall] = useState('large');
    const [merchantVal, setMerchantVal] = useState(''); // Set contain date update from merchant info
    const [profileupdate, setProfileupdate] = useState(''); // Set contain date update from profile update

    // Notification
    const [prdOutofStockCount, setPrdOutofStockCount] = useState('');
    const [prdExpireSoonCount, setPrdExpireSoonCount] = useState('12');

    useEffect(() => {
        checkLogin();
        const leftMenuResize = localStorage.getItem("leftMenuResize");
        if (leftMenuResize != null) {
            setMenuSmall(leftMenuResize);
        }
    }, []);

    const checkLogin = async () => {
        try {
            if (useAuth.checkPermissionNull()) {
                await axiosPrivate.get('authtoken');
                setLoading(false);
            } else {
                useAuth.Logout();
                navigate("/login");
            }

        } catch (error) {
            console.log('error', error);
        }
    }

    const logout = async () => {
        try {
            useAuth.Logout();
            navigate("/login");
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        ScreenWidth(window.innerWidth);
        const handleResize = () => ScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const ScreenWidth = (widthSize) => {
        if (widthSize < '1400') {
            localStorage.setItem("leftMenuResize", 'small');
            setMenuSmall('small');
        }
    }

    // Loading
    if (loading) {
        return (
            <Box sx={{ display: 'flex' }}>
                <CircularProgress className='tyLoadingPosition' />
            </Box>
        )
    }

    // Main layout show
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Appbar
                    mainMenuActive={outletContext.mainMenuActive}
                    menuActive={outletContext.menuActive}
                    pageTitle={outletContext.pageTitle}
                    prdOutofStockCount={prdOutofStockCount}
                    prdExpireSoonCount={prdExpireSoonCount}
                    setMenuSmall={setMenuSmall}
                    menuSmall={menuSmall}
                    merchantVal={merchantVal}
                    profileupdate={profileupdate}
                />
                <Box sx={{
                    display: 'flex',
                    width: '100%'
                }}>
                    <Box position="fixed">
                        <Box
                            component="nav"
                            sx={{
                                marginTop: '0px',
                                width: (menuSmall == 'large') ? '250px' : '75px',
                                //transition: 'width 0.5s',
                                height: "calc(100vh - 60px)",
                                display: { xs: 'none', md: 'block' },
                                overflowY: 'auto',
                                backgroundColor: 'background.leftmenu',
                                padding: '10px',
                                zIndex: '1100',
                                '@media screen and (max-width: 1400px)': {
                                    //width: '75px',
                                },
                            }}
                        >
                            <Leftmenu
                                drawerStatus='no'
                                mainMenuActive={outletContext.mainMenuActive}
                                menuActive={outletContext.menuActive}
                                menuStatus={menuSmall}
                                prdOutofStockCount={prdOutofStockCount}
                                prdExpireSoonCount={prdExpireSoonCount}
                                merchantVal={merchantVal}
                            />
                        </Box>

                        <Box sx={{
                            width: (menuSmall == 'large') ? '250px' : '75px',
                            padding: (menuSmall == 'large') ? '8px 0px 13px 20px' : '5px 0px 13px 12px',
                            marginTop: '0px',
                            backgroundColor: 'background.leftmenu',
                            display: { xs: 'none', md: 'block' },
                            borderStyle: 'solid',
                            borderWidth: '1px 0px 0px 0px',
                            borderColor: 'boderColor.default',
                            fontSize: '14px'
                        }} >
                            <Tooltip title='ອອກຈາກລະບົບ'>
                                <IconButton
                                    size="large"
                                    aria-label="show 17 new notifications"
                                    color="inherit"
                                    sx={{ display: (menuSmall == 'large') ? 'none' : 'show' }}
                                    onClick={logout}
                                >
                                    <Logout sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>
                            <Button
                                variant="text"
                                sx={{ color: 'text.default', display: (menuSmall == 'large') ? 'show' : 'none' }}
                                startIcon={<Logout sx={{ fontSize: '20px' }} />}
                                onClick={logout}
                            >
                                ອອກຈາກລະບົບ
                            </Button>
                        </Box>
                    </Box>

                    <Box sx={{ minWidth: (menuSmall == 'large') ? '210px' : '40px', display: { xs: 'none', md: 'block' } }} />
                    <Box
                        component="main"
                        position="static"
                        sx={{
                            height: "calc(100vh - 10%)",
                            flexGrow: 1,
                            overflowY: 'auto',
                            justifyContent: 'center',
                            alignItems: 'center',
                            //marginTop: '70px',
                            marginTop: '60px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            //width: '600px',
                            padding: "30px 30px 0px 50px",
                            '@media screen and (max-width: 900px)': {
                                padding: "0px 5px 0px 5px",
                            },
                        }}
                    >
                        <Outlet
                            context={{
                                setOutletContext,
                                setPrdExpireSoonCount,
                                setPrdOutofStockCount,
                                prdOutofStockCountSoon: prdOutofStockCount,
                                prdExpireSoonCount,
                                setMenuSmall,
                                menuSmall,
                                merchantVal,
                                setMerchantVal,
                                setProfileupdate
                            }}
                        />
                    </Box>
                </Box >
            </Box >

            {/***  Modal popup alert*/}
            <AlertPopup
                width='400px'
                props={alertPopup}
            />
        </>
    )

}

export default MainLayoutOld